import axios from '@/app/plugins/Axios'

export default new class FornecedoresService {

  listar(paginacao) {
    return axios.get('fornecedores', {params: paginacao})
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/fornecedores/' + id)
      .then(response => response.data);
  }

  salvar(fornecedor) {
    return axios.post('/fornecedores', fornecedor)
      .then(response => response.data);
  }

  atualizar(fornecedor) {
    return axios.put('/fornecedores/'+ fornecedor.id, fornecedor)
      .then(response => response.data);
  }
  
  buscar(busca) {
    return axios.get('/fornecedores/buscar', { params: {search: busca} })
      .then(response => response.data);
  }

  excluir(id) {
    return axios.delete('/fornecedores/' + id)
      .then(response => response.data);
  }

  listarProdutosFornecedor(id) {
    return axios.get(`/fornecedores/${id}/produtos`)
      .then(response => response.data);
  }

  listarContas(fornecedor_id) {
    return axios.get(`/contas/${fornecedor_id}`)
      .then(response => response.data);
  }

  salvarConta(conta) {
    return axios.post(`/contas`, conta).then(response => response.data);
  }

  atualizarConta(conta) {
    return axios.put(`/contas/${conta.id}`, conta)
      .then(response => response.data);
  }

  excluirConta(conta_id) {
    return axios.delete(`/contas/${conta_id}`)
      .then(response => response.data);
  }

  exibirConta(conta_id) {
    return axios.get(`/contas/${conta_id}`)
      .then(response => response.data);
  }

  salvarChavePix(chavepix) {
    return axios.post(`/chavespix`, chavepix).then(response => response.data);
  }

  atualizarChavePix(chavepix) {
    return axios.put(`/chavespix/${chavepix.id}`, chavepix)
      .then(response => response.data);
  }

  excluirChavePix(chavepix_id) {
    return axios.delete(`/chavespix/${chavepix_id}`)
      .then(response => response.data);
  }

  exibirChavePix(chavepix_id) {
    return axios.get(`/chavespix/${chavepix_id}`)
      .then(response => response.data);
  }

  listarContasChaves(fornecedor_id) {
    return axios.get(`/fornecedor/${fornecedor_id}/contas-chaves`)
      .then(response => response.data);
  }
}
